import clsx from 'clsx';
import React, { forwardRef } from 'react';

import styles from './ImageFallback.module.scss';

interface IImageFallbackProps {
  className?: string;
  src?: string | null;
  onClick?: React.MouseEventHandler;
  imageClassName?: string;
  title?: string;
}

const ImageFallback: React.ForwardRefRenderFunction<HTMLDivElement, IImageFallbackProps> = (
  { className, src, onClick, children, imageClassName, title },
  ref,
) => {
  return (
    <div ref={ref} className={clsx(styles.wrap, className)} onClick={onClick} aria-label={title}>
      {src && <div className={clsx(styles.body, imageClassName)} style={{ backgroundImage: `url(${src})` }} />}
      {children}
    </div>
  );
};

export default forwardRef<HTMLDivElement, React.PropsWithChildren<IImageFallbackProps>>(ImageFallback);
